import { Box } from '@material-ui/core';
import { AppTabs } from 'components';
import * as React from 'react';
import CandidateVacanciesView from 'views/CandidateVacancies/CandidateVacanciesView';
import VacancyCandidatesView from 'views/VacancyCandidates/VacancyCandidatesView';
import { MatcherIntroDialog } from './MatcherGuide';

type MatcherTab = 'candidates' | 'vacancies';

const INTRO_DISMISSED_KEY = 'vacancy_matcher_intro_dismissed';

const tabs: { label: string; value: MatcherTab }[] = [
  { label: 'Find Candidates', value: 'candidates' },
  { label: 'Find Vacancies', value: 'vacancies' },
];

const VacancyMatcherView: React.FC = () => {
  const [introOpen, setIntroOpen] = React.useState(
    () => localStorage.getItem(INTRO_DISMISSED_KEY) !== 'true',
  );
  // the tab whose guide runs right after the intro closes
  const [guideTab, setGuideTab] = React.useState<MatcherTab | null>(null);

  return (
    <AppTabs tabs={tabs}>
      {(activeTab) => (
        // both stay mounted so a search and its results survive a tab switch
        <>
          <Box display={activeTab === 'candidates' ? 'block' : 'none'}>
            <VacancyCandidatesView
              startGuide={guideTab === 'candidates'}
              onGuideStarted={() => setGuideTab(null)}
            />
          </Box>
          <Box display={activeTab === 'vacancies' ? 'block' : 'none'}>
            <CandidateVacanciesView
              startGuide={guideTab === 'vacancies'}
              onGuideStarted={() => setGuideTab(null)}
            />
          </Box>
          <MatcherIntroDialog
            open={introOpen}
            onDone={() => {
              localStorage.setItem(INTRO_DISMISSED_KEY, 'true');
              setIntroOpen(false);
              setGuideTab(activeTab);
            }}
          />
        </>
      )}
    </AppTabs>
  );
};

export default VacancyMatcherView;
